import { createI18n } from 'vue-i18n'
import {
  es as vuetifyEs,
  de as vuetifyDe,
  en as vuetifyEn,
  fr as vuetifyFr,
} from 'vuetify/locale'

import commonDe from '../locales/de/common.json'
import componentDe from '../locales/de/components.json'
import commonEn from '../locales/en/common.json'
import componentEn from '../locales/en/components.json'
import commonEs from '../locales/es/common.json'
import componentEs from '../locales/es/components.json'
import commonFr from '../locales/fr/common.json'
import componentFr from '../locales/fr/components.json'

const fallbackLocalePriorities = ['en', 'fr', 'de']

const loadLocaleMessages = () => {
  const paginationNumbers = {
    '10': '10',
    '25': '25',
    '50': '50',
    '100': '100',
  }

  return {
    es: {
      ...paginationNumbers,
      ...componentEs,
       common: {
        ...componentEs.common,
        ...commonEs.common,
      },
       $vuetify: vuetifyEs,
    },
    de: {
      ...paginationNumbers,
      ...componentDe,
      common: {
        ...componentDe.common,
        ...commonDe.common,
      },
      $vuetify: vuetifyDe,
    },
    en: {
      ...paginationNumbers,
      ...componentEn,
      common: {
        ...componentEn.common,
        ...commonEn.common,
      },
      $vuetify: vuetifyEn,
    },
    fr: {
      ...paginationNumbers,
      ...componentFr,
      common: {
        ...componentFr.common,
        ...commonFr.common,
      },
      $vuetify: vuetifyFr,
    },
  }
}

const navigatorLanguage = navigator?.language.slice(0, 2)

const baseNumberFormat = {
  decimal: { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 2 } as const,
}

export default createI18n({
  locale: navigatorLanguage,
  fallbackLocale: fallbackLocalePriorities,
  messages: loadLocaleMessages(),
  numberFormats: {
    'en': baseNumberFormat,
    'fr': baseNumberFormat,
    'de': baseNumberFormat,
    'es': baseNumberFormat,
  },
  legacy: false,
  globalInjection: true,
})

export type AvailableLocale = keyof ReturnType<typeof loadLocaleMessages>
